import type { ReactNode } from "react";
import { Platform, Pressable, Text } from "react-native";

export function Pill({
  selected,
  onPress,
  children,
  theme = "light",
}: {
  selected: boolean;
  onPress?: () => void;
  children: ReactNode;
  theme?: "light" | "dark";
}) {
  const containerCls =
    theme === "dark"
      ? selected
        ? "border-amber bg-amber/15"
        : "border-white/15 bg-white/5"
      : selected
        ? "border-amber bg-amber/10"
        : "border-sand-dark bg-white";
  const textCls =
    theme === "dark"
      ? selected
        ? "font-semibold text-amber"
        : "text-white/60"
      : selected
        ? "font-semibold text-forest"
        : "text-forest/55";
  const cursorWeb = Platform.OS === "web" ? ({ cursor: "pointer" } as const) : {};
  return (
    <Pressable
      onPress={onPress}
      style={cursorWeb}
      className={`rounded-pill border px-3.5 py-1.5 ${containerCls}`}
    >
      <Text className={`text-xs ${textCls}`} style={{ fontFamily: "DMSans_500Medium" }}>
        {children}
      </Text>
    </Pressable>
  );
}
